module.exports=module.exports = "{\n  \"tiny\": \"240px\",\n  \"small\": \"320px\",\n  \"xsmall\": \"550px\",\n  \"medium\": \"768px\",\n  \"large\": \"1024px\",\n  \"xlarge\": \"1280px\",\n  \"xxlarge\": \"1440px\"\n}\n";
